export const MAX_SIZE_IN_BYTES = 5 * 1024 * 1024;
export const VALID_EXEL_FORMAT = ['.xlsx', '.csv'];
export const HR_ID_COLUMN = 'HRCloud Employee ID';
export const NAME_COLUMN = 'Name';
export const NO_FILL = 'No need to fill in';
export const SENT_TO_ID = 'sentToId';
export const SENT_TO_EMAIL = 'sentToEmail';
export const UPLOAD_USER_INFO = 'Please, upload the file you have just filled in with the information - and all the fields will be automatically set into your letter.';
export const DOWNLOAD_USER_INFO = 'Please, download the templates containing HRCloud users you have selected for the letter and newly added users as an Excel file and fill in all the required information. Please, ensure that no required field is empty. Save the file.';
export const EXEL_ERROR_TYPE = {
    EmptyDynamicFields: 'EMPTY_DYNAMIC_FIELDS',
    MissedValues: 'MISSED_VALUES',
    HeaderError: 'HEADER_ERROR',
    IdsError: 'IDS_ERROR',
}
